module.exports = __webpack_public_path__ + "img/cardBg.eedf5fa7.png";